module.exports = __webpack_public_path__ + "static/media/LogoEuroparc.48c11564.png";